import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import ModalUpdateClientsSellsman from "components/ModalUpdateClientsSellsman/ModalUpdateClientsSellsman";
import ModalAddClientsSellsman from "components/ModalAddClientsSellsman/ModalAddClientsSellsman";
import ModalViewTabulation from "components/ModalViewTabulation/ModalViewTabulation";
import ModalAllTabulationSellsman from "components/ModalAllTabulationSellsman/ModalAllTabulationSellsman";
import ModalViewContacts from "components/ModalViewContacts/ModalViewContacts";
import ModalUpdateClientZone from "components/ModalUpdateClientZone/ModalUpdateClientZone";
import useAuth from "hooks/useAuth";
//matiral components
import { makeStyles } from "@material-ui/core/styles";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TableChart from '@material-ui/icons/TableChart';
import Edit from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Pagination from '@material-ui/lab/Pagination';
import FormatLineSpacingIcon from '@material-ui/icons/FormatLineSpacing';
import CustomInput from "components/CustomInput/CustomInput.js";
import Search from "@material-ui/icons/Search";
import Icon from "@material-ui/core/Icon";
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import styles3 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    colorRed: {
        color: 'red'
    },
    colorOrange: {
        color: '#ff9500'
    },
    colorBlack: {
        color: '#0000'
    }
};
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
const useStyles3 = makeStyles(styles3);

export default function ClientsSellsman() {
    const { storageId } = useAuth();
    const classes = useStyles();
    const classes2 = useStyles2();
    const classes3 = useStyles3();

    const [search, setSearch] = useState("")
    const [modal, setModal] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowTabulation, setModalShowTabulation] = useState(false);
    const [modalAllTabulation, setModalAllTabulation] = useState(false);
    const [modalContacts, setModalContacts] = useState(false);
    const [modalShowZone, setModalShowZone] = useState(false);
    const [clients, setClients] = useState([]);
    const [index, setIndex] = useState({ id: 1 });
    const [totalPages, setTotalPages] = useState();
    const [page, setPage] = useState(1);

    useEffect(() => {
        getAllClients();
    }, []);

    const loadModal = async () => {
        setModal(true);
    };
    function callModalAdd() {
        if (!modalShowUpdate) {
            loadModal();
        };
        setModalShow(true);
    };
    function callModal(index) {
        if (!modalShowUpdate) {
            loadModal();
        };
        setIndex(index);
        setModalShowUpdate(true);
    };
    function callModalTabulation(index) {
        if (!modalShowTabulation) {
            loadModal();
        };
        setIndex(index);
        setModalShowTabulation(true);
    };
    function callModalContacts(index) {
        if (!modalContacts) {
            loadModal();
        };
        setIndex(index);
        setModalContacts(true);
    };
    function callModalAllTabulation() {
        if (!modalAllTabulation) {
            loadModal();
        };
        setModalAllTabulation(true);
    };
    function callModalZone(index) {
        if (!modalShowZone) {
            loadModal();
        }
        setIndex(index);
        setModalShowZone(true);
    }
    useEffect(() => {
        loatTotal();
        getAllClients();
    }, [totalPages, page, search]);
    const handleChange = (event, value) => {
        setPage(value);
    };
    async function getAllClients() {
        try {
            let response;
            if (search === "") {
                response = await api.get('/client/sellsman/' + storageId + '/' + page + '/' + "null");
            } else {
                response = await api.get('/client/sellsman/' + storageId + '/' + page + '/' + search);
            };
            setClients(response.data);
        } catch (error) {
            alert('erro: ' + error)
        };
    };
    async function loatTotal() {
        try {
            const response = await api.get('/client/total/sellsman/' + storageId);
            setTotalPages(response.data);
        } catch (error) {
            alert('erro: ' + error);
        };
    };
    function getClientsForTable() {
        let teste = [];
        for (let i = 0; i < clients.length; i++) {
            teste[i] = [];
            teste[i].push(clients[i].fantasy_name);
            if (clients[i].disabled) {
                teste[i].push(<div className={classes.colorRed}>{clients[i].social_reason}</div>);
            } else if (!clients[i].enable) {
                teste[i].push(<div className={classes.colorOrange}>{clients[i].social_reason}</div>);
            } else {
                teste[i].push(<div>{clients[i].social_reason}</div>);
            };
            teste[i].push(clients[i].cnpj);
            teste[i].push(`${clients[i].address}, ${clients[i].number}, ${clients[i].neighborhood}, ${clients[i].city} - ${clients[i].cep}`);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Contatos" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalZone(clients[i])}>
                            <VisibilityIcon className={classes2.tableActionButtonIcon + " " + classes2.view} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Contatos" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalContacts(clients[i])} >
                            <ContactPhoneIcon className={classes2.tableActionButtonIcon2 + " " + classes2.table} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <CardIcon>
                        <Icon title={clients[i].aproved_admin ? "Validado" : "Não validado"}>{clients[i].aproved_admin ? "done" : "clear"}</Icon>
                    </CardIcon>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Tabelas de preço" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalTabulation(clients[i])} >
                            <FormatLineSpacingIcon className={classes2.tableActionButtonIcon + " " + classes2.table} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModal(clients[i])}>
                            <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };
        return teste;
    };
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <p className={classes.colorCard}>Clique abaixo para adicionar um cliente</p>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => callModalAdd()}>
                            Adicionar cliente
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <div className={classes3.searchWrapper}>
                    <CustomInput
                        formControlProps={{
                            className: classes3.margin + " " + classes3.search
                        }}
                        inputProps={{
                            placeholder: "Busca por cnpj, razão social ou nome fantasia",
                            inputProps: {
                                "aria-label": "Search",
                                type: "text",
                                value: search,
                                onChange: event => setSearch(event.target.value)
                            }
                        }}
                    />
                    <Button color="white" aria-label="edit" justIcon round>
                        <Search />
                    </Button>
                </div>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={"primary"}>
                    <h4 className={classes.cardTitleWhite}>Clientes destinados a operação</h4>
                    <div className={classes.acctAll}>
                        <Tooltip id="tooltip-top" title={"Relatório com todas as tabelas de todos os clientes"} placement="top" classes={{ tooltip: classes2.tooltip }} >
                            <IconButton aria-label="Done" className={classes2.tableActionButton} onClick={() => callModalAllTabulation()} >
                                <TableChart className={classes2.tableActionButtonIcon + " " + classes2.edit2} />
                            </IconButton>
                        </Tooltip>
                    </div>
                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Nome fantasia", "Razão Social", "CPF/CNPJ", "Endereço", "Zona", "Contato", "Validação", "Ações"]}
                        tableData={getClientsForTable()}
                    />
                </CardBody>
            </Card>
            {modalShowTabulation && modal && (
                <ModalViewTabulation key={String("Tabulation_" + index.id)} props={index} show={modalShowTabulation} onHide={() => setModalShowTabulation(false)} getAllClients={getAllClients} />
            )}

            {modalShow && modal && (
                <ModalAddClientsSellsman key={String("Cli_" + index.id)} props={index} show={modalShow} onHide={() => setModalShow(false)} getAllClients={getAllClients} />
            )}
            {modalShowUpdate && modal && (
                <ModalUpdateClientsSellsman key={String("Upd_" + index.id)} props={index} show={modalShowUpdate} onHide={() => setModalShowUpdate(false)} getAllClients={getAllClients} />
            )}

            {modalAllTabulation && modal && (
                <ModalAllTabulationSellsman key={String('all_' + index.id)} show={modalAllTabulation} onHide={() => setModalAllTabulation(false)} />
            )}

            {modalContacts && modal && (
                <ModalViewContacts key={String("Con_" + index.id)} props={index} show={modalContacts} onHide={() => setModalContacts(false)} getAllClients={getAllClients} />
            )}
            {modalShowZone && modal && (
                <ModalUpdateClientZone key={`Zone_${index.id}`} props={index} show={modalShowZone} onHide={() => setModalShowZone(false)} getAllClients={getAllClients} />
            )}
            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer>
    );

}
